import product1 from './assets/aoi.webp';
import product2 from './assets/mahoraga.webp';
import product3 from './assets/jjk1.webp';
import product4 from './assets/berserk.webp';
import product5 from './assets/vagabond.webp';
import product6 from './assets/vagabondwhite.webp';
import product7 from './assets/vinland.webp';
import product8 from './assets/zoro.webp';
import product9 from './assets/madokaover.webp';
import product10 from './assets/lanaover.webp';
import product11 from './assets/milfover.webp';
export const PRODUCTS = [
    {
        id: 1,
        productName: "Tee Aoi",
        price: 20000,
        productImage: product1,
    },
    {
        id: 2,
        productName: "Tee Mahoraga",
        price: 20000,
        productImage: product2,
    },
    {
        id: 3,
        productName: "Tee Jjk",
        price: 20000,
        productImage: product3,
    },
    {
        id: 4,
        productName: "Tee Berserk",
        price: 20000,
        productImage: product4,
    },
    {
        id: 5,
        productName: "Tee Vagabond Black",
        price: 20000,
        productImage: product5,
    },
    {
        id: 6,
        productName: "Tee Vagabond White",
        price: 20000,
        productImage: product6,
    },
    {
        id: 7,
        productName: "Tee Vinland",
        price: 20000,
        productImage: product7,
    },
    {
        id: 8,
        productName: "Tee Zoro",
        price: 20000,
        productImage: product8,
    },
    {
        id: 9,
        productName: "Tee Madoka",
        price: 20000,
        productImage: product9,
    },
    {
        id: 10,
        productName: "Tee Lana",
        price: 20000,
        productImage: product10,
    },
    {
        id: 11,
        productName: "Tee MILLF",
        price: 20000,
        productImage: product11,
    },
]